import { assert } from '@varos/util-typescript';
import { IntegrationLoaderBaseConfig } from '../../../integration/base';
import { SolutionToolLoader } from './solutionPartInterface';
import { SolutionToolAggregate } from './solutionPartModel';

export function createSolutionToolLoader(
    config: IntegrationLoaderBaseConfig
): SolutionToolLoader {
    const { repository } = config;

    return {
        useLoad(context, props): SolutionToolAggregate {
            const { tool } = props.item;

            // Assert that there's at least one document artifact
            const firstArtifact = tool.result?.artifacts?.[0];
            assert(firstArtifact, 'Solution must have at least one document artifact');

            const documentQuery = repository.research.document.useLookupMaybe(
                context,
                firstArtifact.id,
                {
                    suspense: true,
                    staleTime: Infinity,
                }
            );
            assert(documentQuery.status === 'success', 'expected suspense');

            return {
                definition: props.item.definition,
                instance: props.item.instance,
                message: props.item.message,
                tool: props.item.tool,
                document: documentQuery.data ?? null,
            };
        },
    };
}
